import { lazy } from "react";

const DataScheduler = lazy(() => import("../modules/admin/data-scheduler"));
const UserList = lazy(() => import("../modules/admin/user-list"));
const ManageApps = lazy(() => import("../modules/admin/manage-apps"));

export const Admins = [
  {
    path: "manage-user",
    element: <UserList />,
  },
  {
    path: "manage-apps",
    element: <ManageApps />,
  },
  {
    path: "data-scheduler",
    element: <DataScheduler />,
  }
];
